import React from 'react'
import styled from 'styled-components'

import Socials from '../components/Socials'
import MadeBy from '../components/MadeBy'

const Container = styled.div`
  position: fixed;
  z-index: 5;

  bottom: 7.6388888889%;

  display: none;
  justify-content: space-between;
  width: 100%;
  padding: 0 56px;
  padding: 0 4.59%;

  @media (min-width: 992px) {
    display: inline-flex;
  }
`

const Footer = () => (
  <Container>
    <Socials />
    <MadeBy />
  </Container>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js